import { useEffect, useState } from "react";
import { SystemActions } from "redux-store";
import { StorageUtil } from "utils";
import { useDispatch } from "react-redux";

import HandlingUnreadMessage from "./HandlingUnreadMessage";
import HandlingBlockAccount from "./HandlingBlockAccount";
import HandlingOnlineStatus from "./HandlingOnlineStatus";
import HandlingBranchInvite from "./HandlingBranchInvite";
import HandlingFocusApp from "./HandlingFocusApp";

import HandleAppEvents from "./HandleAppEvents";
import HandlingMigrateVersion from "./HandlingMigrateVersion";
import HandleScreenLock from "./HandleScreenLock";
import HandlingRequestNotice from "./HandlingRequestNotice";
import HandlingDisappearMsg from "./HandlingDisappearMsg";
import { getInteractor } from "services/local.service";
import { AppConstant, KeyConstant } from "const";
import { useNetworkStatus } from "hooks";

const HandlingParallel = () => {
  const dispatch = useDispatch();
  const { isOnline, serverStatuses } = useNetworkStatus();
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);
  const [isServerOnline, setIsServerOnline] = useState(false);

  useEffect(() => {
    const serverStatus = serverStatuses[branchId];
    setIsServerOnline(serverStatus !== undefined ? serverStatus : false);
  }, [serverStatuses, branchId]);

  useEffect(() => {
    if (isOnline && isServerOnline) {
      dispatch(SystemActions.executeQueue());
    }
  }, [isOnline, isServerOnline]);

  useEffect(() => {
    // Synchronize branch data
    dispatch(SystemActions.synchronizeData(prefixKey));
    dispatch(SystemActions.synchronizeAllBranchData(prefixKey));
    // Handle api_call: change delay_message -> message
    getInteractor(prefixKey)
      .LocalApiCallService.update(
        {
          task: AppConstant.API_CALL_TASK.message,
        },
        {
          task: AppConstant.API_CALL_TASK.delay_message,
        },
      )
      .then(() => {
        dispatch(SystemActions.executeQueue());
      });
  }, [prefixKey]);

  return (
    <>
      <HandlingBlockAccount />
      <HandlingUnreadMessage />
      <HandlingOnlineStatus />
      <HandlingBranchInvite />
      <HandlingFocusApp />

      <HandleAppEvents />
      <HandlingMigrateVersion />
      <HandleScreenLock />

      <HandlingRequestNotice />
      <HandlingDisappearMsg />
    </>
  );
};
export default HandlingParallel;
